export const convertStringToSnakeCase = (value: string): string => {
  return value
    .split(/ |\B(?=[A-Z])/)
    .map((word: string) => word.toLowerCase())
    .join('_');
};
